import { useState } from 'react';
import api from 'services/api';

const S = {
  wrap: { marginTop: 16, padding: 16, background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8 },
  header: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 },
  badge: { background: 'linear-gradient(135deg, #8B1A1A, #C8A84E)', color: '#fff', padding: '2px 8px', borderRadius: 10, fontSize: 10, fontWeight: 700 },
  title: { fontSize: 13, fontWeight: 600, color: '#333' },
  input: { width: '100%', padding: '8px 12px', fontSize: 13, border: '1px solid #d0d0d0', borderRadius: 6, outline: 'none', boxSizing: 'border-box' },
  btn: { padding: '6px 14px', fontSize: 12, fontWeight: 600, border: 'none', borderRadius: 6, cursor: 'pointer', background: 'linear-gradient(135deg, #8B1A1A, #C8A84E)', color: '#fff', marginTop: 8 },
  result: { marginTop: 12, padding: 12, background: '#FEFCE8', border: '1px solid #FDE68A', borderRadius: 8 },
  text: { fontSize: 12, color: '#333', lineHeight: 1.6 },
  ecriture: { marginTop: 8, padding: 8, background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 6, fontFamily: 'monospace', fontSize: 12 },
};

export default function AssistantComptable() {
  const [question, setQuestion] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const ask = async () => {
    if (question.trim().length < 5) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const r = await api.post('/ia/analyze/comptabilite', { question: question.trim() });
      setResult(r.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la consultation IA');
    } finally { setLoading(false); }
  };

  const handleKey = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); ask(); } };

  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <span style={S.badge}>IA</span>
        <span style={S.title}>Assistant comptable SYSCOHADA</span>
      </div>
      <p style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>
        Posez une question sur l'imputation comptable, le choix de compte ou le journal.
      </p>

      <div style={{ display: 'flex', gap: 8 }}>
        <input
          style={S.input}
          value={question}
          onChange={e => setQuestion(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Ex : Dans quel compte imputer l'achat de gilets pare-balles ?"
          disabled={loading}
        />
        <button style={{ ...S.btn, opacity: loading ? 0.6 : 1, whiteSpace: 'nowrap' }} onClick={ask} disabled={loading || question.trim().length < 5}>
          {loading ? '...' : 'Demander'}
        </button>
      </div>

      {error && <p style={{ color: '#DC2626', fontSize: 12, marginTop: 8 }}>{error}</p>}

      {result && (
        <div style={S.result}>
          {result.reponse && <p style={S.text}>{result.reponse}</p>}

          {result.comptes_suggeres?.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <strong style={{ fontSize: 12 }}>Comptes :</strong>
              <ul style={{ margin: '4px 0', paddingLeft: 20, fontSize: 12, lineHeight: 1.8 }}>
                {result.comptes_suggeres.map((c, i) => (
                  <li key={i}><span style={{ fontFamily: 'monospace', fontWeight: 700 }}>{c.numero}</span> {c.libelle} <span style={{ color: '#888' }}>({c.sens})</span></li>
                ))}
              </ul>
            </div>
          )}

          {result.ecriture_type && (
            <div style={S.ecriture}>
              <strong>Ecriture type :</strong> D: {result.ecriture_type.debit} / C: {result.ecriture_type.credit} — Journal: {result.ecriture_type.journal}
            </div>
          )}

          {result.reference_ohada && (
            <p style={{ fontSize: 11, color: '#666', marginTop: 8, fontStyle: 'italic' }}>Ref. OHADA : {result.reference_ohada}</p>
          )}

          {result.fromCache && <span style={{ fontSize: 10, color: '#888' }}>(cache)</span>}
        </div>
      )}
    </div>
  );
}
